import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { InfoText } from '../../theme';
import { Button } from '../button/button.component';
import { Input } from '../input/input.component';
import { Markdown } from '../markdown/markdown.component';

import { BottomContainerProps } from './artworkSummary.types';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-size: 40px;
  line-height: 44px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: -0.01em;
  margin-top: 32px;
`;

export const Attribute: StyledComponent<'p'> = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Light};
  color: ${Color.Gray500};
  margin-top: 8px;

  & + & {
    margin-top: 4px;
  }
`;

export const MarkdownAttribute: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Light};
  color: ${Color.Gray500};
  margin-top: 8px;

  & + ${Attribute} {
    margin-top: 4px;
  }

  strong {
    font-weight: ${FontWeight.Medium};
  }
`;

export const Price: StyledComponent<'div'> = styled.div``;

export const PricePrefix: StyledComponent<'div'> = styled.div`
  margin-right: 4px;
`;

export const PriceContainer: StyledComponent<'div'> = styled.div`
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  font-weight: ${FontWeight.Medium};
  display: flex;
  margin-top: 24px;
`;

export const StyledInfoText: StyledComponent<typeof InfoText> = styled(InfoText)`
  min-width: 210px;
`;

export const StyledButton: StyledComponent<typeof Button> = styled(Button)`
  & + & {
    margin-top: 10px;
  }
`;

export const BottomContainer: StyledComponent<'div', BottomContainerProps> = styled.div<BottomContainerProps>`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  border-bottom: 1px solid ${Color.Gray300};
  padding-bottom: ${({ $withBottomPadding }: BottomContainerProps): string => $withBottomPadding ? '40px' : '0'};
`;

export const Label: StyledComponent<'div'> = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Medium};
  padding-top: 21px;
  border-top: 1px solid ${Color.Gray300};
`;

export const InfoButton: StyledComponent<'button'> = styled.button`
  position: relative;
  margin-left: 8px;
  width: 20px;
  height: 20px;

  :hover {
    ${StyledInfoText} {
      opacity: 1;
    }
  }
`;

export const StyledInput: StyledComponent<typeof Input> = styled(Input)`
  margin-bottom: 10px;
`;

export const TimerContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
`;

export const CountDown: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-top: 20px;
`;

export const CountDownLabel: StyledComponent<'p'> = styled.p`
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Light};
  color: ${Color.Gray500};
  margin-top: 4px;
`;

export const SalesFinished: StyledComponent<'div'> = styled.div`
  margin: 20px auto;
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
  text-align: center;
`;
